import { call, put } from 'redux-saga/effects';

import {globalContentLoaded, curriculumLoaded, homePageContentLoaded, activitySetLoaded} from '../actions/contentful';
import { decrementInitialLoaders } from '../actions/global';
import { getGlobalContent, getHomePageContent } from '../api/graphql/query/global.queries';
import {getCurriculumShape, getSet} from '../api/graphql/curriculum';
import { adaptCurriculumShape } from '@/modules/curriculum/tree';
import * as globalApi from '../api/global';

export function* loadGlobalContent() {
  try {
    let { data } = yield call(getGlobalContent, (new Date()).getTime());
    //let { data: { HomePageQuery } } = yield call(getHomePageContent);

    const payload = { searchkey: '', options: { where: {} } };

    let { data: {
      hqConfigControl,
      languages,
      locales,
      programTypes,
    } } = yield call(globalApi.getGlobalInfo, payload);

    data = {
      ...data,
      hqConfig: hqConfigControl,
      languages,
      locales,
      programTypes,
    };
    yield put(globalContentLoaded(data));

    yield put(decrementInitialLoaders());
  } catch {
    yield put(decrementInitialLoaders());
  }
}

export function* loadHomePageContent() {
  try {
    let { data } = yield call(getHomePageContent);

    yield put(homePageContentLoaded(data));
  } catch (e) {
    // TODO: throw generic error
    console.log('TODO: handle error here');
    console.log(e);
  }
}

export function* loadCurriculum({ payload: { programId, partnershipId, studentView } }) {
  try {
    const { data, errors } = yield call(getCurriculumShape, programId, partnershipId, studentView);
    const shape = data?.CurriculumShapeQuery;

    if (!shape) {
      const message = errors?.map(error => error.message)?.join('; ')
        || 'CurriculumShapeQuery returned no data';

      throw new Error(message);
    }

    yield put(curriculumLoaded(adaptCurriculumShape(shape)));
  } catch (e) {
    // TODO: throw generic error
    console.log('TODO: handle error here');
    console.log(e);
  }
}

export function* loadActivitySet({ payload: { activitySetId, activitySetSlug, permissionContext } }) {
  try {
    const { data } = yield call(getSet, { activitySetId, activitySetSlug }, permissionContext);

    yield put(activitySetLoaded(data));
  } catch (e) {
    console.error(`Failed to load activity set ${activitySetId ?? activitySetSlug}`, e);
    yield put(activitySetLoaded({ ActivitySetQuery: null }));
  }
}
